import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { each, values, indexOf } from 'lodash';
import {
  fetchTVCollectorMappings,
  fetchTVProductMappings,
} from '../../SetupActions';
import { getTVCollectorMappings, getTVCollectorRefs } from '../../SetupReducer';
import { fetchPrograms } from '../../../Nomination/NominationActions';

import ProgressBar from '../../../../components/progress-bar';
import { getCanSetupOrganization } from '../../../Auth/AuthReducer';

class RequiredTVCollectorMappingSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loaded: false,
      error: null,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchData() {


    this.setState({ loading: true, loaded: false, error: null });

    const p1 = this.props.dispatch(fetchTVProductMappings());
    const p2 = this.props.dispatch(fetchPrograms());
    const p3 = this.props.dispatch(fetchTVCollectorMappings());
    Promise.all([p1, p2, p3])
      .then(
        () => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: true });
          }
        },
        (e) => {
          if (this.mounted) {
            this.setState({ loading: false, loaded: false, error: e.data || e });
          }
        },
      );
  }

  renderContent() {
    const {
      canSetup, location, collectors, types,
      children, collectorRefs,
      allowDisabled, allowNoSetup, silent,
    } = this.props;
    const checkCollectors = {};
    const inactiveCollectors = [];
    const checkAvailableCollectors =  [];

    if (collectors && collectors.length > 0) {
      each(collectors, (client) => {
        each(client.programs, (program) => {
          each(types, (type) => {
            /*
            if (program[`${type}_collector_id`]) {
              
              if (collectorRefs[client.id] && collectorRefs[client.id][program.id]) {
                const cols = collectorRefs[client.id][program.id];
                each(cols, (col) => {
                  if (program[`${type}_collector_id`] === col.collector_id) {
                    checkCollectors[`${type}|${col.collector_id}`] = {
                      ...col,
                      collector_type: type,
                      program,
                    };
                    if (!col.is_active) {
                      inactiveCollectors.push(col);
                    }
                  }
                });
              }
            }
            */
            const programCollectorIds = program[`${type}_all_in_used_collector_ids`] || [];
            const programAvailableCollectorIds = program[`${type}_all_collector_ids`] || [];

            if (collectorRefs[client.id] && collectorRefs[client.id][program.id]) {
              const cols = collectorRefs[client.id][program.id];
              each(cols, (col) => {
                if (indexOf(programCollectorIds, col.collector_id) >= 0) {
                  checkCollectors[`${type}|${col.collector_id}`] = {
                    ...col,
                    collector_type: type,
                    program,
                  };
                  if (!col.is_active) {
                    inactiveCollectors.push(col);
                  }
                }
                if (indexOf(programAvailableCollectorIds, col.collector_id) >= 0) {
                  checkAvailableCollectors[`${type}|${col.collector_id}`] = {
                    ...col,
                    collector_type: type,
                    program,
                  };
                }
              });
            }


          });
        });
      });
    }

    const validCollectors = values(checkCollectors);
    const validAvailableCollectors = values(checkAvailableCollectors);

    const hasSetup = validCollectors.length > 0;
    if (silent && !hasSetup) {
      return children(validCollectors, validAvailableCollectors);
    }

    if ((!hasSetup && !allowNoSetup) || inactiveCollectors.length > 0) {
      const r = location ? location.pathname : null;
      const warnning = (
        <div>
          <div key="content">
            <p />
            {inactiveCollectors.length > 0 &&
              <div>
                <div className="alert alert-danger">
                  {inactiveCollectors.length === 1 && <span>The following collector is not active:</span>}
                  {inactiveCollectors.length !== 1 && <span>These collectors are not active:</span>}
                  <ul>
                    {inactiveCollectors.map((c) => {
                      return (
                        <li key={c.collector_id}>{c.collector_name}</li>
                      );
                    })}
                  </ul>
                </div>
                {allowDisabled && children(validCollectors, validAvailableCollectors)}
              </div>
            }
            {inactiveCollectors.length === 0 &&
              <div>
                <div className="alert alert-warning">
                  {canSetup &&
                    <div>
                      <p>You need to have at least one automation group enabled and connect to an active collector.</p>
                      <p>Please setup <Link to={`/setup/feedback-requests/automations?r=${r}`}><u>Automation Groups</u></Link> before using this feature.</p>
                      {collectors.length > 0 && false &&
                        <ul>
                          {collectors.map((client) => {
                            return (
                              <li key={client.id}>
                                <div>Client: {client.name}</div>
                                {client.programs !== undefined && client.programs !== null && client.programs.length &&
                                  <ul>
                                    {client.programs.map((program) => {
                                      const hasCollector = program.collector_id !== null && program.collector_id !== undefined;
                                      return (
                                        <li key={program.id}>
                                          <div>Program: <strong>{program.name}</strong></div>
                                          {!hasCollector && <div><Fa name="exclamation-triangle" /> You need to have at least one automation group enabled and connect to an active collector.</div>}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                }
                              </li>
                            );
                          })}
                        </ul>
                      }
                    </div>
                  }
                  {!canSetup &&
                    <div>
                      <p>Please note that your organization needs to setup the <strong>TruVoice Survey Collectors</strong> before using this feature.</p>
                      <p>Contact a TruVoice Automation&trade; manager for your organization to have them complete the setup process.</p>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      );
      return (
        <div>
          {warnning}
        </div>
      );
    }

    return children(validCollectors, validAvailableCollectors);
  }

  renderError() {
    const { error } = this.state;
    const message = error.message || 'An error occurred';
    return (
      <div className="alert alert-danger">
        {message}
      </div>
    );
  }

  render() {
    const { loading, loaded, error } = this.state;
    if (loading) {
      return (
        <div>
          <p><em>Initializing collectors</em></p>
          <ProgressBar />
        </div>
      );
    }
    if (loaded && error) {
      return this.renderError();
    }
    return this.renderContent();
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const collectors = getTVCollectorMappings(state);
  return {
    collectors,
    collectorRefs: getTVCollectorRefs(state),
    canSetup: getCanSetupOrganization(state),
  };
}

RequiredTVCollectorMappingSetup.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  collectors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  collectorRefs: PropTypes.shape({}),
  canSetup: PropTypes.bool.isRequired,
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowDisabled: PropTypes.bool,
  allowNoSetup: PropTypes.bool,
  children: PropTypes.func,
  silent: PropTypes.bool,
};
RequiredTVCollectorMappingSetup.defaultProps = {
  children: () => {},
  collectorRefs: {},
  allowDisabled: false,
  allowNoSetup: false,
  programLoading: false,
  programLoaded: false,
  silent: false,
};

export default connect(mapStateToProps)(withRouter(RequiredTVCollectorMappingSetup));
